export const CREATE_GROUP_ERROR = 'CREATE_GROUP_ERROR';
export const CREATE_GROUP_SUCCESS = 'CREATE_GROUP_SUCCESS';

export const DELETE_GROUP_ERROR = 'DELETE_GROUP_ERROR';
export const DELETE_GROUP_SUCCESS = 'DELETE_GROUP_SUCCESS';

export const UNDELETE_GROUP_ERROR = 'UNDELETE_GROUP_ERROR';

export const UPDATE_GROUP_ERROR = 'UPDATE_GROUP_ERROR';
export const UPDATE_GROUP_SUCCESS = 'UPDATE_GROUP_SUCCESS';

export const FILTER_GROUPS = 'FILTER_GROUPS';
export const LOAD_GROUPS_SUCCESS = 'LOAD_GROUPS_SUCCESS';
export const UNLOAD_GROUPS_SUCCESS = 'UNLOAD_GROUPS_SUCCESS';

//=============================
// SIDE EFFECT ACTION TYPES
//=============================
export const GROUPS_STUDENT_ALREADY_STAGED = 'GROUPS_STUDENT_ALREADY_STAGED'
export const GROUPS_STAGE_STUDENT_SUCCESS = 'GROUPS_STAGE_STUDENT_SUCCESS'
export const GROUPS_STAGE_STUDENT_ERROR = 'GROUPS_STAGE_STUDENT_ERROR'
export const GROUPS_UNDEFINED_STUDENT_RECORD = 'GROUPS_UNDEFINED_STUDENT_RECORD'

export const CURRENT_USER_CREATE_GROUP_SUCCESS = 'CURRENT_USER_CREATE_GROUP_SUCCESS'
export const CURRENT_USER_CREATE_GROUP_ERROR = 'CURRENT_USER_CREATE_GROUP_ERROR'

export const CREATE_SINGLE_GROUP_CONFLICT = 'CREATE_SINGLE_GROUP_CONFLICT'
export const CREATE_GROUP_CONFLICT = 'CREATE_GROUP_CONFLICT'

export const STUDENT_UNDO_GROUP_SUCCESS = 'STUDENT_UNDO_GROUP_SUCCESS'
export const STUDENT_TRANSACTION_ERROR_GROUP_CREATION = 'STUDENT_TRANSACTION_ERROR_GROUP_CREATION'
export const STUDENT_TRANSACTION_ERROR_UNDO = 'STUDENT_TRANSACTION_ERROR_UNDO'


// WEBPACK FOOTER //
// ./src/core/groups/action-types.js